import { render } from "./OnboardingUnsuccessful.vue?vue&type=template&id=98b7733e&scoped=true"
import script from "./OnboardingUnsuccessful.vue?vue&type=script&lang=js"
export * from "./OnboardingUnsuccessful.vue?vue&type=script&lang=js"

import "./OnboardingUnsuccessful.vue?vue&type=style&index=0&id=98b7733e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b7733e"]])

export default __exports__